import React, { Component } from 'react';
import { TextField, Button, Stack, Paper, Divider } from '@mui/material';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import CodeIcon from '@mui/icons-material/Code';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import KeyIcon from '@mui/icons-material/Key';
// eslint-disable-next-line
// import styled from 'styled-components/macro';

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: '#ffff',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

class ScriptPage extends Component {
	state = {
		copiedPid: false,
		copiedToken: false,
	};
	onCopyPid = () => {
		if (!this.state.copiedPid) this.setState({ copiedPid: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copiedPid: false });
		}, 2000);
	};
	onCopyToken = () => {
		if (!this.state.copiedToken) this.setState({ copiedToken: true });
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ copiedToken: false });
		}, 2000);
	};
	render() {
		let product = this.props.product;
		return (
			<Page title="Developers" subtitle="Token" icon={<CodeIcon />}>
				<Stack spacing={2}>
					<Item>
						<Divider sx={{ fontSize: '17px' }} textAlign="left">
							<KeyIcon /> Token
						</Divider>
						<form style={{ textAlign: 'left' }}>
							<TextField
								fullWidth
								margin="normal"
								label="Product ID"
								value={product.id}
								onChange={({ target: { value } }) => this.setState({ value, copiedToken: false })}
								action
								InputProps={{
									endAdornment: (
										<CopyToClipboard text={product.id} onCopy={this.onCopyPid}>
											<Button
												sx={{ borderRadius: '4px' }}
												color={this.state.copiedPid ? 'success' : undefined}
												size="medium"
												variant="contained"
												endIcon={this.state.copiedPid ? <DoneIcon /> : <ContentCopyIcon />}
											>
												{this.state.copiedPid ? 'Copied' : 'Copy'}
											</Button>
										</CopyToClipboard>
									),
								}}
							></TextField>

							{product.settings && product.settings.wapi_token ? (
								<TextField
									fullWidth
									label="Token"
									margin="normal"
									value={product.settings.wapi_token}
									onChange={({ target: { value } }) => this.setState({ value, copiedToken: false })}
									action
									InputProps={{
										endAdornment: (
											<CopyToClipboard text={product.settings.wapi_token} onCopy={this.onCopyToken}>
												<Button
													sx={{ borderRadius: '4px' }}
													color={this.state.copiedToken ? 'success' : undefined}
													size="medium"
													variant="contained"
													endIcon={this.state.copiedToken ? <DoneIcon /> : <ContentCopyIcon />}
												>
													{this.state.copiedToken ? 'Copied' : 'Copy'}
												</Button>
											</CopyToClipboard>
										),
									}}
								></TextField>
							) : (
								''
							)}
						</form>
					</Item>
				</Stack>
			</Page>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(ScriptPage);
